import I18n from '../config/i18n';

export function getLimitationName(
  state: string | number | undefined,
  isLimitation: boolean | undefined,
): string | undefined {
  return !isLimitation || !state
    ? undefined
    : {
        1: 'allowed',
        2: 'forbidden',
        3: 'onrequest',
      }[state];
}

function renderLimitation(state: string | number | undefined): string {
  return I18n.t(`host.limitation.${getLimitationName(state, true)}`);
}

export function renderValue(
  value: string | number | undefined,
  isLimitation: boolean | undefined,
): string | number | undefined {
  return isLimitation ? renderLimitation(value) : value;
}

export function renderInfo(
  info: string | number | undefined,
  isLimitation: boolean | undefined,
): string | number | undefined {
  return isLimitation ? '' : info;
}
